import Vue from 'vue'
import Vuex from 'vuex'

import { getState } from './state'
import { getters } from './getters'
import { mutations } from './mutations'
import { actions } from './actions'

import { authState, authGetters, authMutations, authActions } from './auth'

Vue.use(Vuex)

export default new Vuex.Store({
    state: getState(),
    getters,
    mutations,
    actions,
    modules: {
        auth: {
            state: authState,
            getters: authGetters,
            mutations: authMutations,
            actions: authActions
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js